module.exports = __webpack_public_path__ + "assets/img/3caf5bf4ac1770d6068a4ae48ec27c90.png";